import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  containerPadding: {
    padding: [unit * 3.75, unit * 5.5, unit * 5.5]
  }
});
export default createUseStyles(styles);
